import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AdminNav from "../../components/adminNav/AdminNav";
import "./adminEmails.css";

const PAGE_SIZE = 20;

export const AdminEmails = () => {
  const [emails, setEmails] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [previewHtml, setPreviewHtml] = useState(null);

  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));

  const fetchEmails = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL_FETCH_EMAILS}?page=${page}&limit=${PAGE_SIZE}`,
      );
      setEmails(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch (err) {
      console.error("Failed to fetch emails:", err);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchEmails();
  }, [fetchEmails]);

  return (
    <div className="admin">
      <AdminNav />
      <div className="emailsTable">
        <h2 style={{ margin: "0 0 16px", color: "#333" }}>
          Odeslané emaily ({total})
        </h2>

        {loading ? (
          <p>Načítání…</p>
        ) : emails.length === 0 ? (
          <p>Žádné emaily k zobrazení.</p>
        ) : (
          <>
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Příjemce</th>
                  <th>Předmět</th>
                  <th>Stav</th>
                  <th>Chyba</th>
                  <th>Odesláno</th>
                  <th>Akce</th>
                </tr>
              </thead>
              <tbody>
                {emails.map((email, index) => (
                  <tr
                    key={email.id}
                    className={
                      index % 2 === 0 ? "table-row-even" : "table-row-odd"
                    }
                  >
                    <td>{email.id}</td>
                    <td>{email.recipient}</td>
                    <td className="subjectCell">{email.subject}</td>
                    <td>
                      <span
                        className={`statusBadge statusBadge--${email.status}`}
                      >
                        {email.status}
                      </span>
                    </td>
                    <td className="errorCell">{email.error_msg || "—"}</td>
                    <td>
                      {dayjs(email.sent_at).format("DD.MM.YYYY HH:mm")}
                    </td>
                    <td>
                      <button
                        className="viewBtn"
                        onClick={() => setPreviewHtml(email.html_body)}
                        title="Zobrazit email"
                      >
                        <VisibilityIcon style={{ height: 20, width: 20 }} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="paginationControls">
              <button
                onClick={() => setPage(1)}
                disabled={page <= 1}
              >
                {"«"}
              </button>
              <button
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page <= 1}
              >
                {"‹"}
              </button>
              <span className="paginationInfo">
                Strana {page} z {pageCount}
              </span>
              <button
                onClick={() => setPage((p) => Math.min(pageCount, p + 1))}
                disabled={page >= pageCount}
              >
                {"›"}
              </button>
              <button
                onClick={() => setPage(pageCount)}
                disabled={page >= pageCount}
              >
                {"»"}
              </button>
            </div>
          </>
        )}
      </div>

      <Dialog
        open={previewHtml !== null}
        onClose={() => setPreviewHtml(null)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Náhled emailu
          <IconButton onClick={() => setPreviewHtml(null)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {previewHtml && (
            <iframe
              srcDoc={previewHtml}
              title="Email preview"
              style={{
                width: "100%",
                height: "70vh",
                border: "1px solid #ddd",
                borderRadius: 4,
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
